import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, DoCheck, AfterViewInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductVersionImageModel, ProductVersionModel } from '../../../models/product/product-version.model';
import { TokenOtkViewModel } from '../../../models/tokens/token.model';
import { CommonService, ProductService } from '../../../services';
import { ClrDatagrid, ClrDatagridStateInterface } from '@clr/angular';

@Component({
  selector: 'app-token-table',
  templateUrl: './token-table.component.html',
  styleUrls: ['./token-table.component.scss']
})
export class TokenTableComponent implements OnInit, DoCheck, AfterViewInit {
  
  tokenLoading: boolean;
  @Input() model: ProductVersionModel;
  tokens: Array<TokenOtkViewModel> = [];

  @Input() selectedImage: ProductVersionImageModel;
  @Output() countChanged: EventEmitter<number> =   new EventEmitter();
   
  filterItems: any = {
    token: { key: 'token', name: 'Token' },
    link: { key: 'link', name: 'Url' },
    createdOn: { key: 'createdOn', name: 'Created On' },
    invoiceId: { key: 'invoiceId', name: 'Invoice Id' }
  }
  filters = [];

  @ViewChild('dataGrid') dataGrid: ClrDatagrid;


  tokenSummary: any = {};
  tokenActiveStates: any = {};
  tokenData: Array<TokenOtkViewModel> = [];

  constructor(
    private readonly prodSrv: ProductService,
     private readonly toastr: ToastrService,
     private readonly cdref: ChangeDetectorRef,
     public common: CommonService
     ) { }

  ngOnInit(): void {
    this.getTokens(false);
  }

  ngDoCheck() {
    this.reloadLbl();
}
ngAfterViewInit(){
    this.reloadLbl();
}

defaultTokenSummary() {
  return { sold: 0, active: 0, inactive: 0 };
}

defaultTokenStates() {
  return { sold: false, active: false, inactive: false };
}

reloadLbl(){
       
    this.cdref.detectChanges();
}

refresh() {
  this.getTokens(true);
}

onGridStateChange(state: ClrDatagridStateInterface) {
  this.filters = state?.filters || [];
}

  getTokens(force?: boolean) {
    this.tokenLoading = true;
    this.tokenSummary = this.defaultTokenSummary();
    this.tokenActiveStates = this.defaultTokenStates();
    this.tokenData = [];
    this.prodSrv.getTokensByVersion(this.model.id, force).subscribe(
      data => this.onGetTokens(data),
      err => this.onGetTokensError(err));
  }

  onGetTokens(data) {
    this.tokenSummary = this.defaultTokenSummary();
    this.tokenActiveStates = this.defaultTokenStates();
    this.tokenLoading = false;
    if (data['result']) {
      this.tokens = [];
      this.tokenData = [];
      data['result'].forEach(x => {
        const parseData = TokenOtkViewModel.parse(x);
        if(parseData?.soldOn) {
          this.tokenSummary['sold'] += 1;
        } else if(!parseData?.isActive) {
          this.tokenSummary['inactive'] += 1;
        } else if(parseData?.isActive && !parseData?.soldOn) {
          this.tokenSummary['active'] += 1;
        } 
        this.tokens.push(parseData);
        this.tokenData.push(parseData);
      });
    }
  }
  
  onGetTokensError(err) {
    this.tokenLoading = false;
    this.onError(err);
  }

  onError(_) {
    this.toastr.error('Something went wrong!');
  }

  openInvoice(id){
    this.countChanged.emit(id);
  }

  setTokenActiveState(state: string) {
    this.tokenActiveStates[state] = !this.tokenActiveStates[state];
    this.filterByTokenStaus();
  }

  filterByTokenStaus() {
    if(this.tokenActiveStates?.sold || this.tokenActiveStates?.active || this.tokenActiveStates?.inactive) {
    this.tokens = this.tokenData.filter(x => ((this.tokenActiveStates?.sold && x.soldOn) || 
    (this.tokenActiveStates?.inactive && !x.isActive) || 
    (this.tokenActiveStates?.active && x.isActive && !x.soldOn)));
    } else {
      this.tokens = JSON.parse(JSON.stringify(this.tokenData));
    }
  }

}
